import script from "./Heading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Heading.vue?vue&type=script&setup=true&lang=ts"

import "./Heading.vue?vue&type=style&index=0&id=18573a10&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18573a10"]])

export default __exports__